import reduceReducers from "reduce-reducers";

import { BILLING_RUN, SET_CURRENT_LIVESTOCKSALE } from "constants/actionTypes";

import {
  apiModelOfflineCreateReducer,
  apiModelOfflineDeleteReducer,
  apiModelOfflineFetchReducer,
  apiModelOfflineUpdateReducer,
  defaultInitialState,
  resetStateOnRoleChangeReducer,
} from "lib/reducers";
import { deserializeBillingRun } from "lib/serializers/billingRuns";

const create = apiModelOfflineCreateReducer(BILLING_RUN, {
  deserializer: deserializeBillingRun,
});

const fetch = apiModelOfflineFetchReducer(BILLING_RUN, {
  deserializer: deserializeBillingRun,
  clearOnRequest: true,
  finishLoadingAfterChanges: true,
});

const update = apiModelOfflineUpdateReducer(BILLING_RUN, {
  deserializer: deserializeBillingRun,
});

const deleteReducer = apiModelOfflineDeleteReducer(BILLING_RUN);

function extraBillingRunReducer(state, action) {
  switch (action.type) {
    case SET_CURRENT_LIVESTOCKSALE.REQUEST:
      if (action.shouldNavigate) {
        // If we are navigating to a different livestock sale, reset the state (clear all data and active billing run)
        // This event also fires on mount (ie refreshing), we don't want to clear the selected billing run unless we are navigating.
        return defaultInitialState;
      }
      return state;
    case BILLING_RUN.ENABLE.ACTION:
      return { ...state, isEnabled: true };
    case BILLING_RUN.DISABLE.ACTION:
      return { ...state, isEnabled: false };
    case BILLING_RUN.SUBSCRIBE.ACTION:
      return { ...state, activeBillingRunId: action.id };
    case BILLING_RUN.CREATE.REQUEST: {
      return { ...state, activeBillingRunId: null };
    }
    case BILLING_RUN.CHECK_FOR_CHANGES.REQUEST: {
      return { ...state, isCheckingForChanges: true };
    }
    case BILLING_RUN.CHECK_FOR_CHANGES.FAILURE:
    case BILLING_RUN.CHECK_FOR_CHANGES.SUCCESS: {
      return { ...state, isCheckingForChanges: false };
    }
    case BILLING_RUN.UNSUBSCRIBE.ACTION:
      return {
        ...state,
        activeBillingRunId: null,
      };

    default:
      return state;
  }
}

const billingRunReducer = reduceReducers(
  create,
  fetch,
  update,
  deleteReducer,
  extraBillingRunReducer,
  resetStateOnRoleChangeReducer,
);

export default billingRunReducer;
